<template>
  <CDataTable
    :items="computedItems"
    :fields="fields"
    hover
    :items-per-page-select="{label: 'Einträge pro Seite'}"
    :items-per-page="25"
    column-filter
    sorter
    pagination
  >
    <template #no-items-view><NoData/></template>

    <template #actionbar="{item}">
      <td nowrap="" width="1%">
        <CButton
          color="primary"
          variant="outline"
          square
          size="sm"
          v-c-tooltip="{content: 'Editieren', placement:'left'}"
          v-on:click="editEntry(item.leistungid)"
        >
          <CIcon name="cil-highlighter"/>
        </CButton>
        <CButton
          color="success"
          variant="outline"
          size="sm"
          class="ml-2"
          v-c-tooltip="{content: 'Inaktiv setzen', placement:'left'}"
          v-on:click="toggleAktiv(item.leistungid)"
          v-if="item.aktiv"
        >
          <CIcon name="cil-lock-unlocked"/>
        </CButton>
        <CButton
          color="danger"
          variant="outline"
          size="sm"
          class="ml-2"
          v-c-tooltip="{content: 'Aktiv setzen', placement:'left'}"
          v-on:click="toggleAktiv(item.leistungid)"
          v-if="!item.aktiv"
        >
          <CIcon name="cil-lock-locked"/>
        </CButton>
        <CButton
          color="danger"
          variant="outline"
          size="sm"
          class="ml-2"
          v-c-tooltip="{content: 'Löschen', placement:'left'}"
          v-on:click="deleteEntry(item.leistungid)"
          v-if="!item.aktiv"
        >
          <CIcon name="cil-trash"/>
        </CButton>
      </td>
    </template>
  </CDataTable>
</template>

<script>
import Vue from 'vue'
import NoData from '@/components/NoData'

export default {
  name: 'LeistungenTable',
  props: {
    leistungen: Array,
    value: String
  },
  components: {
    NoData
  },
  data () {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'actionbar',
          label: '',
          _style: 'width:1%',
          sorter: false,
          filter: false
        }
      ]
    }
  },
  mounted () {
  },
  computed: {
    computedItems () {
      if (this.leistungen) {
        if (this.leistungen.length > 0) {
          return this.leistungen.map(lst => {
            const result = {
              leistungid: lst.leistungid,
              aktiv: lst.aktiv,
              name: lst.name
            }

            return result
          })
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  methods: {
    editEntry (leistungid) {
      this.$router.push({ path: `/leistungen/editieren/${leistungid}` })
    },
    toggleAktiv: function (leistungid) {
      const self = this
      const options = {
        okText: 'Ja',
        cancelText: 'Nein'
      }
      self.$dialog
        .confirm('Den Status des Mitarbeiters wirklich ändern?', options)
        .then((dialog) => {
          Vue.axios.put('/leistung/toggle/aktiv/' + leistungid)
            .then(function (response) {
              self.$snotify.success('Der Status der Leistung wurde geändert.', {
                position: 'rightTop',
                timeout: 4000
              })
              self.$emit('input', leistungid)
            })
        })
        .catch(() => {
          // Do Nothing
        })
    },
    deleteEntry: function (leistungid) {
      const self = this
      const options = {
        okText: 'Ja',
        cancelText: 'Nein'
      }
      this.$dialog
        .confirm('Die Leistung wirklich löschen?', options)
        .then((dialog) => {
          Vue.axios.delete('/leistung/delete/' + leistungid)
            .then((response) => {
              self.$snotify.error('Die Leistung wurde gelöscht.', {
                position: 'rightTop',
                timeout: 4000
              })
              self.$emit('input', leistungid)
            })
        })
        .catch(() => {
          // Do Nothing
        })
    }
  }
}
</script>
